// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"bd27e593","616":"40d7f312","885":"c79a3a64"}[chunkId] + ".chunk.js";
};